module.exports = __webpack_public_path__ + "static/media/backgroundHome.ff96d6ea.svg";